<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش هدایا باشگاه مشتریان</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="mr-3" :extraQuery="excelUrl" :url="url" />
      </div>
      <div class="row px-4 not-in-print">
        <div class="row col-12 mb-1">
          <DatePickerRange class="col-md-12" v-model="filterDate" />
          <b-form-group class="col-6">
            <multiselect
                placeholder="انتخاب انبار"
                v-model="selectedStore"
                open-direction="bottom"
                :options="stores"
                label="label"
                class="mt-2"
                track-by="id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :disabled="disabled"
            >
                <template slot="noOptions"> موردی یافت نشد </template>
                <template slot="noResult"> موردی یافت نشد </template>
            </multiselect>
            </b-form-group>
        </div>
        <b-button
          class="col-md-2 mt-2"
          variant="primary"
          @click="doFilter"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template v-slot:cell(sum_received_scores)="data">
            {{ data.item.sum_received_scores | price }}
          </template>
          <template v-slot:cell(sum_received_wallets)="data">
            {{ data.item.sum_received_wallets | price }}
          </template>
          <template v-slot:cell(current_score)="data">
            {{ data.item.current_score | price }}
          </template>
          <template v-slot:cell(current_wallet)="data">
            {{ data.item.current_wallet | price }}
          </template>
          <template #bottom-row="data">
            <b-td colspan="3">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
              {{ totals.sum_received_score | price }}
            </b-td>
            <b-td>
              {{ totals.sum_received_wallets | price }}
            </b-td>
            <b-td>
              *
            </b-td>
            <b-td>
              {{ totals.current_wallet | price }}
            </b-td>
          </template>
        </b-table>

        <div v-if="!reports" class="alert alert-primary">دیتایی وجود ندارد</div>
        <div v-else-if="disabled" class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

function Filter() {
  this.search = "";
}
Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};
export default {
  name: "PhysicalClub",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    Treeselect,
    ExcelDownload,
    DatePickerRange,
    ProductSearch,
    BButton,
    BTd,
  },
  configProvider,
  data() {
    return {
      url:'admin/reports/physical-club',
      disabled: false,
      fields: [
        {
          key: "id",
          label: "شناسه مشتری",
          sortable: true,

        },
        {
          key: "name",
          label: "نام",
          sortable: true,

        },
         {
          key: "mobile",
          label: "موبایل مشتری",
          sortable: true,

        },
        {
          key: "sum_received_scores",
          label: "مجموع امتیاز های دریافت شده ",
          sortable: true,

        },
        {
          key: "sum_received_wallets",
          label: "مجموع کیف پول دریافتی از باشگاه",
          sortable: true,

        },
        {
          key: "current_score",
          label: "امتیاز فعلی",
          sortable: true,

        },
      
        {
          key: "current_wallet",
          label: "موجودی کیف پول فعلی",
          sortable: true,

        },
      ],
      page: 1,
      reports: null,
      sortBy: null,
      sortDesc: null,
      totals : [],
      showModal: false,  
        selectedStore: null,
                stores: [],
      filterDate: {
        endDate: "",
        startDate: "",
      },
      filter: new Filter(),
      appliedFilter: new Filter(),
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  created() {
  },
  mounted() {
        this.loadStores();
    },
  computed: {
    excelUrl() {
      const params =  {
            from_date: this.filterDate.startDate,
            to_date: this.filterDate.endDate,
          }
          return params
    },
  },
  methods: {
     async loadStores(){
        try {
            const response = await this.$axios.get("admin/stores");
            this.stores = response.data.data.stores;
            this.disabled = false;
        } catch (e) {
            this.$root.notify(e);
        } 
    },
    resetFilter() {
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    async loadData() {
      this.appliedFilter.set(this.filter);
      this.disabledRest = false;
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/physical-club", {
          params: {
            from_date: this.filterDate.startDate,
            to_date: this.filterDate.endDate,
                            store_id: this.selectedStore ? this.selectedStore.id : '',
          },
        });
        this.reports = response.data.data.datas
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
